/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceVcdsRestricted } from './serviceVcdsRestricted';


export interface VcdsOrgPatchSpec { 
    /**
     * The VCDS org type
     */
    org_type?: string;
    /**
     * Reset the org type overridden flag and recompute VCDS Org type (based on VMC Org type)
     */
    org_type_reset?: boolean;
    /**
     * whether to set the VMC Ungated value passed in vmc_ungated
     */
    patch_vmc_ungated?: boolean;
    /**
     * Set the si_billing_enabled flag
     */
    si_billing_enabled?: boolean;
    vcds_restricted?: ServiceVcdsRestricted;
    /**
     * Set the vmc_ungated flag
     */
    vmc_ungated?: boolean;
}

